var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLock = function SvgLock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#909A9F",
    d: "M34 16v-2c0-5.514-4.486-10-10-10S14 8.486 14 14v6h-2c-2.206 0-4 1.794-4 4v16c0 2.206 1.794 4 4 4h24c2.206 0 4-1.794 4-4V24c0-2.206-1.794-4-4-4H18v-6c0-3.308 2.692-6 6-6s6 2.692 6 6v2z"
  })));
};
export { SvgLock as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDgiIGhlaWdodD0iNDgiIHZpZXdCb3g9IjAgMCA0OCA0OCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTM0IDE2VjE0QzM0IDguNDg2IDI5LjUxNCA0IDI0IDRDMTguNDg2IDQgMTQgOC40ODYgMTQgMTRWMjBIMTJDOS43OTQgMjAgOCAyMS43OTQgOCAyNFY0MEM4IDQyLjIwNiA5Ljc5NCA0NCAxMiA0NEgzNkMzOC4yMDYgNDQgNDAgNDIuMjA2IDQwIDQwVjI0QzQwIDIxLjc5NCAzOC4yMDYgMjAgMzYgMjBIMThWMTRDMTggMTAuNjkyIDIwLjY5MiA4IDI0IDhDMjcuMzA4IDggMzAgMTAuNjkyIDMwIDE0VjE2SDM0WiIgZmlsbD0iIzkwOUE5RiIvPgo8L3N2Zz4K";